import { stringify } from 'hub-http/helpers/params';
import { useLocation } from 'quartz-routing/react-router';
import { useFullShort } from './shortContentQueries';
import { useVideoPlayerConfig } from '../video/videoHooks';
import { useCustomMediaQuery } from '../../utils/Styling';
import { ALLOWED_OTG_IDS, SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS } from './shortContentConstants';
import { getWindow } from '../../utils/browser';
import { SHORT_URL_FRAGMENT } from '../../routes/academyRoutePaths';
export const useHasLearnByDoing = ({
  shortId,
  learnByDoingEnabled,
  isParentWindowDesktop
}) => {
  const isScreenSizeAccepted = useCustomMediaQuery('(min-width: 1024px)');
  return (learnByDoingEnabled === true || ALLOWED_OTG_IDS.includes(shortId)) && (isScreenSizeAccepted || isParentWindowDesktop === true);
};
export const useLearnByDoingLink = ({
  shortId
}) => {
  const currentLocation = useLocation();
  const otgId = shortId;
  const currentSearchParams = new URLSearchParams(currentLocation.search);
  currentSearchParams.delete('backLocation');
  const cleanSearch = currentSearchParams.toString() ? `?${currentSearchParams.toString()}` : '';
  const backLocation = getWindow().location.pathname.startsWith('/academy/') ? `${currentLocation.pathname}${cleanSearch}` : `${SHORT_URL_FRAGMENT}/${otgId}`;
  return `/${SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS}?${stringify({
    otgId,
    isLearnWhileDoing: true,
    backLocation
  })}`;
};
export const useShortVideo = ({
  shortId,
  skip
}) => {
  const {
    short
  } = useFullShort(shortId, skip);
  const {
    autoPlay,
    playSpeed
  } = useVideoPlayerConfig();
  if (!short) return null;
  const {
    reference,
    hubId,
    duration
  } = short;
  return {
    videoId: reference || '',
    autoPlay,
    playSpeed,
    creatorHubId: hubId,
    creatorRegion: short.contentHublet,
    businessObjectives: short.businessObjectives,
    useCases: short.useCases,
    videoDuration: duration,
    visibility: short.visibility
  };
};